export default {
  people: {
    title: 'We Connect People and Technology!',
    description:
      'We know that people are our greatest asset. Therefore, we care for, welcome, train and develop our #teamSIS, through educational, technological, behavioral resources, and health and wellness programs. This way, we ensure deliveries that are in line with expectations and that generate real value for our clients and for our employees.',
  },
}
